// /tickets/feed — chronological activity feed. Merges
// `agent_activity_log` ship events with recently updated tickets,
// filtered by the same 4-axis tab (All / Team / Agents / Me) that
// /tickets/general uses.
//
// Realtime: subscribed to INSERT+UPDATE+DELETE on tickets and
// agent_activity_log via subscribeTicketsRealtime (shared helper).
// Channel name is unique per mount; reconnects with backoff on disconnect.

import { pageBoilerplateFetch } from '../../functions/tickets/ticketUtils.js'
import { fetchActivityFeed } from '../../functions/tickets/fetchActivityFeed.js'
import { subscribeTicketsRealtime } from '../../functions/tickets/subscribeTicketsRealtime.js'

export const feed = {
  extends: 'AppPage',
  metadata: { title: 'Feed / Tickets / Symbols Workspace' },

  fetch: pageBoilerplateFetch,

  onCreate: async (el, s) => {
    const items = await fetchActivityFeed({ limit: 80 })
    const viewHash = (typeof window !== 'undefined' ? (window.location.hash || '') : '')
      .replace(/^#/, '').split('&').reduce((acc, kv) => {
        const [k, v] = kv.split('=')
        if (k) acc[k] = v === undefined ? true : decodeURIComponent(v)
        return acc
      }, {})
    const allowed = new Set(['team', 'agents', 'me'])
    const deeplink = allowed.has(viewHash.view) ? viewHash.view : null
    const patch = { feedItems: items }
    // Only seed filterAssignee if the URL asks for one — otherwise
    // leave whatever the TicketsHeader switcher last set cross-page.
    if (deeplink) patch.filterAssignee = deeplink
    s.root.update(patch)

    el._rtUnsub = subscribeTicketsRealtime({
      pageName: 'feed',
      tables: ['agent_activity_log', 'tickets'],
      onRefresh: async () => {
        const next = await fetchActivityFeed({ limit: 80 })
        if (next.length) s.root.update({ feedItems: next })
      }
    })
  },

  onRemove: (el) => {
    if (el._rtUnsub) { el._rtUnsub(); el._rtUnsub = null }
    const root = el.getRoot()
    if (root && root.selectedTicket) root.update({ selectedTicket: null })
  },

  TicketsSidebar: {},
  TicketsFeedMain: {},
  TicketsNewTicketModal: {},
  TicketsDetailModal: {}
}
